/* mo-sr.js: The Sleep Report index (sections/mo-sr.liquid), Mattress Overstock, 2026-10-14.
   1. Search and topic chips over every article, from the ?view=mo-sr-data feed (templates/blog.mo-sr-data.liquid).
   2. Compare two brands: a pair opens its head-to-head article, or both brands' lineup pages.
   3. The lifespan timeline: bars grow once on first view while the age marker sweeps to its resting year;
      the marker is a keyboard and pointer slider that refills each bar.
   Plain script, no libraries. DOM writes happen only when a value changes (assets/custom.js watches the body). */
(function () {
  'use strict';
  var root = document.querySelector('[data-mo-sr]');
  if (!root || root.dataset.srInit) return;
  root.dataset.srInit = '1';
  root.classList.add('is-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function setText(el, t) { if (el && el.textContent !== String(t)) el.textContent = t; }

  /* ---------------------------------------------------------------- 1. search and topics */
  var TOPIC = {
    life: 'How long beds last', vs: 'Brand vs brand', choose: 'Choosing a bed',
    brand: 'Brands and models', sleep: 'Sleep and the bedroom', store: 'Store news'
  };
  var form = root.querySelector('[data-sr-form]');
  var input = root.querySelector('[data-sr-q]');
  var chips = Array.prototype.slice.call(root.querySelectorAll('.sr-chip--t'));
  var panel = root.querySelector('[data-sr-results]');
  var list = root.querySelector('[data-sr-list]');
  var count = root.querySelector('[data-sr-count]');
  var head = root.querySelector('[data-sr-results-h]');
  var clear = root.querySelector('[data-sr-clear]');
  var feed = null, loading = null, topic = '', timer = 0;

  function load() {
    if (feed) return Promise.resolve(feed);
    if (loading) return loading;
    loading = fetch(root.dataset.feed, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        feed = (d.a || []).map(function (a) {
          a.k = (a.t + ' ' + (a.g || []).join(' ') + ' ' + (TOPIC[a.s] || '') + ' ' + (a.x || '')).toLowerCase();
          a.tl = a.t.toLowerCase();
          return a;
        });
        counts();
        return feed;
      })
      .catch(function () { loading = null; return null; });
    return loading;
  }

  function counts() {
    chips.forEach(function (c) {
      var n = feed.filter(function (a) { return a.s === c.dataset.topic; }).length;
      if (c.querySelector('.sr-chip__n')) return;
      var s = document.createElement('span');
      s.className = 'sr-chip__n';
      s.textContent = n;
      c.appendChild(s);
    });
  }

  function card(a) {
    var img = a.i
      ? '<img src="' + esc(a.i) + '" alt="" width="480" height="360" loading="lazy">'
      : '';
    return '<article class="sr-item" data-topic="' + esc(a.s) + '">' +
      '<a class="sr-item__img" href="' + esc(a.u) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
      '<div class="sr-item__body"><p class="sr-item__meta"><span class="sr-item__topic">' + esc(TOPIC[a.s] || '') +
      '</span><span><time datetime="' + esc(a.dt) + '">' + esc(a.d) + '</time></span><span>' + a.m + ' min read</span></p>' +
      '<h3 class="sr-item__title"><a href="' + esc(a.u) + '">' + esc(a.t) + '</a></h3>' +
      (a.x ? '<p class="sr-item__dek">' + esc(a.x) + '</p>' : '') + '</div></article>';
  }

  function run() {
    var q = (input && input.value || '').trim().toLowerCase();
    if (!q && !topic) { reset(true); return; }
    load().then(function (all) {
      if (!all) { if (form && q) form.submit(); return; }
      var words = q.split(/\s+/).filter(Boolean);
      var hits = all.filter(function (a) {
        if (topic && a.s !== topic) return false;
        return words.every(function (w) { return a.k.indexOf(w) > -1; });
      });
      if (words.length) {
        hits.sort(function (x, y) {
          var sx = words.filter(function (w) { return x.tl.indexOf(w) > -1; }).length;
          var sy = words.filter(function (w) { return y.tl.indexOf(w) > -1; }).length;
          return sy - sx;
        });
      }
      var label = topic ? TOPIC[topic] : 'Search results';
      setText(head, label);
      var what = (q ? ' for "' + input.value.trim() + '"' : '') + (topic && q ? ' in ' + TOPIC[topic] : '');
      setText(count, hits.length === 1 ? '1 article' + what : hits.length + ' articles' + what);
      list.innerHTML = hits.length
        ? hits.map(card).join('')
        : '<p class="sr-results__empty">Nothing matches that yet. Try a brand name, a sleep position or a feel like firm or plush.</p>';
      panel.hidden = false;
    });
  }

  function reset(keepInput) {
    topic = '';
    chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
    if (!keepInput && input) input.value = '';
    if (panel && !panel.hidden) { panel.hidden = true; list.innerHTML = ''; }
  }

  chips.forEach(function (c) {
    c.setAttribute('role', 'button');
    c.setAttribute('aria-pressed', 'false');
    c.addEventListener('click', function (e) {
      e.preventDefault();
      var t = c.dataset.topic;
      topic = topic === t ? '' : t;
      chips.forEach(function (o) { o.setAttribute('aria-pressed', o.dataset.topic === topic ? 'true' : 'false'); });
      run();
    });
    c.addEventListener('keydown', function (e) {
      if (e.key === ' ') { e.preventDefault(); c.click(); }
    });
  });
  if (form) {
    form.addEventListener('submit', function (e) { e.preventDefault(); run(); if (panel) panel.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); });
  }
  if (input) {
    input.addEventListener('focus', load, { once: true });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 140); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { reset(false); } });
  }
  if (clear) clear.addEventListener('click', function () { reset(false); if (input) input.focus(); });
  (window.requestIdleCallback || function (f) { return setTimeout(f, 1200); })(load);

  /* ---------------------------------------------------------------- 2. compare two brands */
  var cmp = root.querySelector('[data-sr-cmp]');
  if (cmp) {
    var data = {};
    try { data = JSON.parse(cmp.querySelector('[data-sr-cmp-data]').textContent); } catch (e) { data = {}; }
    var out = cmp.querySelector('[data-sr-cmp-out]');
    var bchips = Array.prototype.slice.call(cmp.querySelectorAll('.sr-chip--b'));
    var picked = bchips.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; }).map(function (b) { return b.dataset.b; });

    var pick = function (a, kicker) {
      return '<a class="sr-pick" href="' + esc(a.u) + '"><span class="sr-pick__img">' +
        (a.i ? '<img src="' + esc(a.i) + '" alt="" width="480" height="360" loading="lazy">' : '') +
        '</span><span class="sr-pick__body"><span class="sr-kicker">' + esc(kicker) + '</span><span class="sr-pick__t">' +
        esc(a.t) + '</span><span class="sr-meta">' + a.m + ' min read</span></span></a>';
    };
    var show = function () {
      var B = data.brands || {}, P = data.pairs || {}, html = '';
      if (!picked.length) {
        html = '<div class="sr-pick--none"><p>Pick a brand to start. Pick a second to compare.</p></div>';
      } else if (picked.length === 1) {
        var one = P[picked[0]];
        html = one ? pick(one, 'Inside ' + B[picked[0]].n)
          : '<div class="sr-pick--none"><p>Now pick a second brand to compare with ' + esc(B[picked[0]].n) + '.</p></div>';
      } else {
        var key = picked.slice().sort().join('+'), art = P[key];
        if (art) {
          html = pick(art, 'Head-to-head');
        } else {
          var a = B[picked[0]], b = B[picked[1]];
          html = '<div class="sr-pick--none"><p>We have not written ' + esc(a.n) + ' vs ' + esc(b.n) +
            ' yet. Here are both lineups to look at side by side.</p><p class="sr-pick__cols">' +
            '<a class="sr-pick__col" href="' + esc(a.u) + '">' + esc(a.n) + ' lineup</a>' +
            '<a class="sr-pick__col" href="' + esc(b.u) + '">' + esc(b.n) + ' lineup</a></p></div>';
        }
      }
      out.innerHTML = html;
    };
    bchips.forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.dataset.b, at = picked.indexOf(k);
        if (at > -1) picked.splice(at, 1);
        else { picked.push(k); if (picked.length > 2) picked.shift(); }
        bchips.forEach(function (o) { o.setAttribute('aria-pressed', picked.indexOf(o.dataset.b) > -1 ? 'true' : 'false'); });
        show();
      });
    });
  }

  /* ---------------------------------------------------------------- 3. lifespan timeline */
  var life = root.querySelector('[data-sr-life]');
  if (life) {
    var MAX = 16;
    var rows = Array.prototype.slice.call(life.querySelectorAll('.sr-row[data-lo]'));
    var thumb = life.querySelector('[data-sr-thumb]');
    var rail = life.querySelector('.sr-age__rail');
    var ageV = life.querySelector('[data-sr-age-v]');
    var sum = life.querySelector('[data-sr-life-sum]');
    var bub = life.querySelector('[data-sr-bub]');
    var rest = parseFloat(getComputedStyle(life).getPropertyValue('--age')) || 11;
    var age = rest, shown = -1;
    var names = rows.map(function (r) { return r.querySelector('.sr-row__name').textContent; });
    rows.forEach(function (r, i) { r.style.setProperty('--i', i); });

    var states = function (y) {
      rows.forEach(function (r) {
        var lo = +r.dataset.lo, hi = +r.dataset.hi, st = r.querySelector('.sr-row__state');
        var k = y > hi ? 'past' : (y >= lo ? 'in' : 'pre');
        if (st.dataset.st !== k) {
          st.dataset.st = k;
          if (k !== 'pre' && !reduce) {
            r.classList.remove('is-bump');
            void r.offsetWidth;
            r.classList.add('is-bump');
          }
        }
        setText(st, k === 'past' ? 'Past its range' : (k === 'in' ? 'Inside its range' : 'Not there yet'));
      });
    };
    var summary = function (y) {
      var inn = [], past = [];
      rows.forEach(function (r, i) {
        if (y > +r.dataset.hi) past.push(names[i]); else if (y >= +r.dataset.lo) inn.push(names[i]);
      });
      return 'At ' + y + ' years: ' + (inn.length ? 'inside the range for ' + inn.join(', ') : 'inside no brand range') +
        (past.length ? '; past the range for ' + past.join(', ') : '') + '.';
    };
    var set = function (y, announce) {
      age = Math.max(0, Math.min(MAX, y));
      life.style.setProperty('--age', age.toFixed(3));
      var whole = Math.round(age);
      if (whole !== shown) {
        shown = whole;
        setText(ageV, whole);
        setText(bub, whole + ' yrs');
        if (thumb) { thumb.setAttribute('aria-valuenow', whole); thumb.setAttribute('aria-valuetext', whole + ' years'); }
        states(age);
        if (announce) setText(sum, summary(whole));
      }
    };

    /* first view: arm before it scrolls in, then grow the bars and sweep the marker from 0 to rest */
    var played = false;
    var play = function () {
      if (played) return;
      played = true;
      life.classList.add('is-play');
      if (reduce) { set(rest); return; }
      var t0 = 0, dur = 1500;
      var step = function (t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        var e = 1 - Math.pow(1 - p, 3);
        set(rest * e);
        if (p < 1) requestAnimationFrame(step); else set(rest);
      };
      set(0);
      setTimeout(function () { requestAnimationFrame(step); }, 250);
    };
    if (!reduce && 'IntersectionObserver' in window) {
      var r0 = life.getBoundingClientRect();
      if (r0.top > window.innerHeight * 0.9) {
        life.classList.add('is-arm');
        set(0);
        var io = new IntersectionObserver(function (en) {
          if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); play(); }
        }, { threshold: 0.3 });
        io.observe(life.querySelector('.sr-life__rows'));
      } else { played = true; set(rest); }
    } else { played = true; set(rest); }

    /* the slider: drag the thumb or tap the rail; arrows step a year, Page keys three, Home and End the ends */
    var fromX = function (x) {
      var b = rail.getBoundingClientRect();
      return Math.round(((x - b.left) / b.width) * MAX);
    };
    var dragging = false;
    if (rail) {
      rail.addEventListener('pointerdown', function (e) {
        played = true;
        dragging = true;
        life.classList.remove('is-arm');
        life.classList.add('is-drag');
        try { rail.setPointerCapture(e.pointerId); } catch (err) {}
        set(fromX(e.clientX), true);
        if (thumb) thumb.focus({ preventScroll: true });
        e.preventDefault();
      });
      rail.addEventListener('pointermove', function (e) { if (dragging) set(fromX(e.clientX), true); });
      var up = function () { dragging = false; life.classList.remove('is-drag'); };
      rail.addEventListener('pointerup', up);
      rail.addEventListener('pointercancel', up);
    }
    if (thumb) {
      thumb.addEventListener('keydown', function (e) {
        var y = Math.round(age), k = e.key;
        if (k === 'ArrowRight' || k === 'ArrowUp') y += 1;
        else if (k === 'ArrowLeft' || k === 'ArrowDown') y -= 1;
        else if (k === 'PageUp') y += 3;
        else if (k === 'PageDown') y -= 3;
        else if (k === 'Home') y = 0;
        else if (k === 'End') y = MAX;
        else return;
        e.preventDefault();
        played = true;
        life.classList.remove('is-arm');
        set(y, true);
      });
    }
  }
})();
